import React from 'react';
import Button from 'components/ui/Button';
import Input from 'components/ui/Input';
import Icon from 'components/AppIcon';

const FilterToolbar = ({ filters, onFiltersChange, categories, resultCount }) => {
  const handleFilterChange = (key, value) => {
    onFiltersChange(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleClearFilters = () => {
    onFiltersChange({
      search: '',
      category: '',
      stockStatus: '',
      priceRange: ''
    });
  };

  const hasActiveFilters = Object.values(filters).some(value => value !== '');

  return (
    <div className="bg-surface rounded-lg border border-border p-4 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between space-y-4 lg:space-y-0">
        {/* Search and Filters */}
        <div className="flex flex-col lg:flex-row space-y-4 lg:space-y-0 lg:space-x-4">
          {/* Search */}
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Icon name="Search" size={16} color="#9ca3af" />
            </div>
            <Input
              type="text"
              placeholder="Search products..."
              value={filters.search}
              onChange={(e) => handleFilterChange('search', e.target.value)}
              className="pl-10 w-full lg:w-64"
            />
          </div>

          {/* Category Filter */}
          {/* <select
            value={filters.category}
            onChange={(e) => handleFilterChange('category', e.target.value)}
            className="px-3 py-2 border border-input rounded-md focus:ring-2 focus:ring-ring focus:border-transparent"
          >
            <option value="">All Categories</option>
            {categories.map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select> */}

          {/* Stock Status Filter */}
          {/* <select
            value={filters.stockStatus}
            onChange={(e) => handleFilterChange('stockStatus', e.target.value)}
            className="px-3 py-2 border border-input rounded-md focus:ring-2 focus:ring-ring focus:border-transparent"
          >
            <option value="">All Stock Status</option>
            <option value="in-stock">In Stock</option>
            <option value="low-stock">Low Stock</option>
            <option value="out-of-stock">Out of Stock</option>
          </select> */}

          {/* Price Range Filter */}
          {/* <select
            value={filters.priceRange}
            onChange={(e) => handleFilterChange('priceRange', e.target.value)}
            className="px-3 py-2 border border-input rounded-md focus:ring-2 focus:ring-ring focus:border-transparent"
          >
            <option value="">All Price Ranges</option>
            <option value="0-50">$0 - $50</option>
            <option value="51-100">$51 - $100</option>
            <option value="101-200">$101 - $200</option>
            <option value="201+">$201+</option>
          </select> */}
        </div>

        {/* Actions and Results */}
        <div className="flex items-center space-x-4">
          {/* Result Count */}
          <div className="text-sm text-gray-500">
            {resultCount} product{resultCount !== 1 ? 's' : ''} found
          </div>

          {/* Clear Filters */}
          {hasActiveFilters && (
            <Button
              variant="outline"
              size="sm"
              iconName="X"
              onClick={handleClearFilters}
            >
              Clear Filters
            </Button>
          )}

          {/* Advanced Filters */}
          {/* <Button
            variant="outline"
            size="sm"
            iconName="Filter"
            onClick={() => console.log('Advanced filters')}
          >
            Advanced
          </Button> */}
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;